/* Patriot Merch — self-contained wishlist (localStorage) + Klaviyo event helper.
   Guests and logged-in users use localStorage. (Customer-metafield persistence needs a
   backend/app-proxy, so it's intentionally out of scope for this self-contained build.) */
(function () {
  var KEY = 'pm_wishlist';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function write(a) {
    localStorage.setItem(KEY, JSON.stringify(a));
    document.dispatchEvent(new CustomEvent('pm:wishlist', { detail: a }));
    sync();
  }
  function has(h) { return read().some(function (x) { return x.handle === h; }); }
  function add(item) { var a = read(); if (item && item.handle && !has(item.handle)) { a.unshift(item); write(a); } }
  function remove(h) { write(read().filter(function (x) { return x.handle !== h; })); }
  function toggle(item) { if (!item || !item.handle) return false; has(item.handle) ? remove(item.handle) : add(item); return has(item.handle); }
  function count() { return read().length; }
  function sync() {
    document.querySelectorAll('[data-pm-wish]').forEach(function (b) { b.classList.toggle('is-saved', has(b.dataset.pmWish)); });
    document.querySelectorAll('[data-pm-wish-count]').forEach(function (el) { var c = count(); el.textContent = c; el.hidden = c === 0; });
  }

  // Fire a Klaviyo event (onsite object if present; falls back to the client events API
  // with a known email if the shopper opted in earlier). company_id is the public site id.
  var COMPANY = 'XNijXr';
  function knownEmail() { try { return localStorage.getItem('pm_email') || null; } catch (e) { return null; } }
  function klaviyoEvent(metric, props) {
    try {
      if (window.klaviyo) {
        if (typeof window.klaviyo.track === 'function') { window.klaviyo.track(metric, props); }
        else if (typeof window.klaviyo.push === 'function') { window.klaviyo.push(['track', metric, props]); }
      }
    } catch (e) {}
    var email = knownEmail();
    if (email) {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + COMPANY, {
        method: 'POST', headers: { 'content-type': 'application/json', revision: '2026-04-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: metric } } },
          profile: { data: { type: 'profile', attributes: { email: email } } },
        } } })
      }).catch(function () {});
    }
  }

  // Delegated clicks: wishlist toggles + reserve buttons
  document.addEventListener('click', function (e) {
    var wb = e.target.closest && e.target.closest('[data-pm-wish]');
    if (wb) {
      e.preventDefault();
      var item = null; try { item = JSON.parse(wb.getAttribute('data-pm-wish-item')); } catch (err) {}
      if (item) toggle(item);
      return;
    }
    var rb = e.target.closest && e.target.closest('[data-pm-reserve]');
    if (rb) {
      e.preventDefault();
      var ri = null; try { ri = JSON.parse(rb.getAttribute('data-pm-reserve-item')); } catch (err) {}
      if (ri) {
        add(ri); // reserve == save to wishlist
        klaviyoEvent('Reserved Product', { product: ri.title, handle: ri.handle, url: ri.url, price: ri.price, reserved_at: new Date().toISOString() });
        rb.classList.add('is-reserved');
        var lbl = rb.querySelector('[data-pm-reserve-label]');
        if (lbl) lbl.textContent = 'Reserved — saved to your list';
      }
    }
  });
  document.addEventListener('DOMContentLoaded', sync);

  window.PMWishlist = { add: add, remove: remove, toggle: toggle, has: has, list: read, count: count, sync: sync, klaviyoEvent: klaviyoEvent };
})();
